import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import LoaderButton from '../../loader-button/LoaderButton';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Loader from '../../common/Loader';

//
const CredsModal = ({ isTestingValidCredentials, setIsTestingCredentials, fields, testCreds, vendorId }) => {
  return (
    <Fragment>
      <LoaderButton
        isLoading={isTestingValidCredentials}
        onClick={e =>
          vendorId === 'aws' && !fields.awsApiHealthApiRoleArn.length
            ? console.log('missing credentials')
            : ((vendorId === 'vmware' || vendorId === 'msftserver') && !fields.username.length) ||
              ((vendorId === 'vmware' || vendorId === 'msftserver') && !fields.password.length)
            ? console.log('missing credentials')
            : (vendorId === 'cisco' && !fields.supportClientId.length) ||
              (vendorId === 'cisco' && !fields.supportClientSecret.length) ||
              (vendorId === 'cisco' && !fields.cloudAppsUser.length) ||
              (vendorId === 'cisco' && !fields.cloudAppsPass.length)
            ? console.log('missing credentials')
            : vendorId === 'netapp' && !fields.refreshToken.length
            ? console.log('missing credentials')
            : vendorId === 'servicenow' &&
              (!fields.snApiUrl ||
                (fields.authType === 'oauth' ? !fields.clientId || !fields.clientSecret : !fields.user || !fields.pass))
            ? console.log('missing credentials')
            : (vendorId === 'azure' || vendorId === 'msft365') &&
              (!fields.tenantId.length || !fields.appId.length || !fields.clientSecret.length)
            ? console.log('missing credentials')
            : testCreds()
        }
        color="falcon-default"
        size="sm"
        icon="check"
        iconclassname="fs--2"
        style={{ marginRight: '10px' }}
        data-testid={'test-creds-btn'}
      >
        Validate
      </LoaderButton>{' '}
      <Modal
        isOpen={isTestingValidCredentials}
        toggle={() => setIsTestingCredentials(!isTestingValidCredentials)}
        keyboard={false}
        backdrop="static"
      >
        <ModalHeader>Credentials Test</ModalHeader>
        <ModalBody>
          <p>Your credentials are being validated. Please standby...</p>
          <Loader />
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

CredsModal.propTypes = {
  vendorId: PropTypes.string,
  setModalOpen: PropTypes.func,
  modalOpen: PropTypes.bool,
  fields: PropTypes.object,
  isTestingValidCredentials: PropTypes.bool,
  testCreds: PropTypes.func,
  setIsTestingCredentials: PropTypes.func
};

export default CredsModal;
